import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Get } from 'Xhr/Xhr';
import { env } from 'env';

export const fetchPageConfig = async (
  getPageConfig,
  networkErrorMsg
) => {
  Get(
    `${process.env.REACT_APP_API_URL_API_GET_NEW_TURN_CONFIG}`,
    false
  ).then((response) => {
    // console.log('fetchPageConfig=>', response);
    if (response.data.resCode === 1) {
      getPageConfig({
        ...response.data.Data,
        noeEntekhabeNobatPatient: 3,
      });
    } else {
      SwalAlert('error', networkErrorMsg, false);
    }
  });
};
